export function isNullOrUndefined<T>(target: T | null | undefined) : target is T {
  return target === undefined || target === null;
}

export function isNotNullOrUndefined<T>(target: T | null | undefined) : target is T {
  return !isNullOrUndefined(target)
}